import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { addDeliveryAndTip } from '../../../../lib/helper.js';
import defaultMsg from '../../../../translations/lang/en-US.json';

const INVALID_DATE='Invalid date';

class OrderHistoryHeader extends PureComponent {
  expandCollapseClick = () => {
    this.props.expandCollapseClick();   
  }

  //  Keeping existent formatting and validation for diningDate
  formatDiningDate = diningDate => {
    let formattedDate;
    if(diningDate && diningDate !== INVALID_DATE){
      if (diningDate.indexOf('-') !== -1)
        formattedDate = moment(diningDate, 'YYYY-MM-DD').format('MMM D, Y');
      else {
        const diningDateNumber = Number(diningDate);
        if (!isNaN(diningDateNumber) && diningDateNumber !== 0)
          formattedDate = moment(diningDate).format('MMM D, Y');
      }
    }
    return formattedDate;
  }

  addDeliveryAndTip = data => {
    const { amount=0, description } = data;
    const tipAmount = get(description, 'tipAmount', 0);
    return addDeliveryAndTip(amount, tipAmount);
  };

  render() {
    const { order, 
            order:{
              orderId, 
              description:{
                diningDate, 
                diningTime = '', 
                orderType, 
                cardType
              },
              created
            }, 
            group, 
            expanded=true 
          } = this.props;
    const formattedDiningDate = this.formatDiningDate(diningDate);
    const pickupDate = moment(new Date(created)).format('MMM D, Y');

    return (
      <div className="panel-heading">
        <span className="span">
          {orderId}
        </span>
        <span />
        <span className="spanStyle">
          {pickupDate}
        </span>
        <span className="spanStyle olo-client-theme-color" style={{ textTransform: 'uppercase' }}>
          {formattedDiningDate ? `${orderType} ( ${formattedDiningDate} ${diningTime} )` : `${orderType}`}
        </span>
        <span className="spanStyle">
          {this.addDeliveryAndTip(order)}
        </span>
        <span className="pull-right clickable " 
              data-toggle="collapse"
              data-target={`#${group}`}
              aria-expanded="false"
              aria-controls={`${group}`} 
              onClick={this.expandCollapseClick} >
          <FontAwesome name={expanded ? "chevron-down arrowDown" : "chevron-up arrowDown"} />
        </span>
        {cardType ? (
          <span className="spanStyle">
            <FormattedMessage id="paidBy" 
                              defaultMessage={defaultMsg.paidBy}
                              values={{ type: cardType }} />
          </span>
        ) : null}
        <span></span>
      </div>
    );
  }
}

export default OrderHistoryHeader;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryHeader.jsx